import { Theme, useTheme } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import sumBy from 'lodash/sumBy'
import Table from '@mui/material/Table'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import {
  getAllRows,
  getRow0,
  getRow1,
  getRow2,
  getRow3,
  getRow4,
  getSelectedUnits,
} from '../selectors'
import { UseBuildRowsEffect } from './hooks/buildRows'
import { SelectUnitCallback } from './hooks/selectUnit'
import { getUnitNumbers } from '../../../utils/getUnitNumbers'
import { useDimensions } from '../../../hooks/useDimensions'
import { ActionsDivComponent } from '../../Register/Actions'
import { LIComponent, PaperComponent, ULComponent } from './styled'
import {
  getBackgroundClimateColor,
  getBackgroundColor,
  getCursor,
  getSelectedColor,
  getWidth,
} from './utils'
import { actions as registerActions } from '../../Register/reducer'
import { SelectUnit, SelectUnitRow } from '../types'

interface Props {
  children: React.ReactNode
}
const TableComponent: React.FC<Props> = ({ children }) => (
  <Table size="small">
    <tbody>
      <tr>
        <td style={{ padding: 0 }}>{children}</td>
      </tr>
    </tbody>
  </Table>
)

export const UnitsMapComponent: React.FC = () => {
  const dispatch = useDispatch()
  const theme = useTheme<Theme>()
  const { height, width } = useDimensions()
  UseBuildRowsEffect()
  const row0 = useSelector(getRow0) as SelectUnitRow[]
  const row1 = useSelector(getRow1) as SelectUnitRow[]
  const row2 = useSelector(getRow2) as SelectUnitRow[]
  const row3 = useSelector(getRow3) as SelectUnitRow[]
  const row4 = useSelector(getRow4) as SelectUnitRow[]
  const allRows = useSelector(getAllRows) as SelectUnitRow[]
  const selectedUnits = useSelector(getSelectedUnits) as SelectUnit[]

  const { onSelectUnit } = SelectUnitCallback()

  const total = sumBy(selectedUnits, (x) => parseInt(x.value))
  const selected = getUnitNumbers({
    allRows,
  })

  const onActiveStep = React.useCallback(
    (step: number) => {
      dispatch(registerActions.onActiveStep(step))
    },
    [dispatch]
  )

  const isNextDisabled = selected.length !== total
  return (
    <PaperComponent variant="outlined">
      <div style={{ alignSelf: 'start' }}>
        {' '}
        Selected: {selected.length} / {total}
      </div>
      <div
        style={{
          height: height - 130,
          width: width - 100,
          overflow: 'auto',
          display: 'grid',
          justifyContent: 'center',
        }}
      >
        <TableComponent>
          <ULComponent>
            {row0.map((x) => (
              <LIComponent
                onClick={() => onSelectUnit(x)}
                style={{
                  backgroundColor: getBackgroundColor(x, theme),
                  color: getSelectedColor(x, theme),
                  cursor: getCursor(x),
                }}
                key={`row0-${x.id}`}
              >
                <h5 style={{ marginTop: 20 }}>{x.unitNumber}</h5>
                <div>{x.size}</div>
              </LIComponent>
            ))}
          </ULComponent>
        </TableComponent>
        <TableComponent>
          <ULComponent>
            {row1.map((x) => (
              <LIComponent
                onClick={() => onSelectUnit(x)}
                style={{
                  backgroundColor: getBackgroundColor(x, theme),
                  color: getSelectedColor(x, theme),
                  cursor: getCursor(x),
                }}
                key={`row1-${x.id}`}
              >
                <h5 style={{ marginTop: 20 }}>{x.unitNumber}</h5>
                <div>{x.size}</div>
              </LIComponent>
            ))}
          </ULComponent>
        </TableComponent>
        <TableComponent>
          <ULComponent>
            {row2.map((x) => (
              <LIComponent
                onClick={() => onSelectUnit(x)}
                style={{
                  backgroundColor: getBackgroundClimateColor(x, theme),
                  width: getWidth(x),
                  color: getSelectedColor(x, theme),
                  cursor: getCursor(x),
                }}
                key={`row2-${x.id}`}
              >
                <h5 style={{ marginTop: 20 }}>{x.unitNumber}</h5>
                <div>{x.size}</div>
              </LIComponent>
            ))}
          </ULComponent>
        </TableComponent>
        <TableComponent>
          <ULComponent>
            {row3.map((x) => (
              <LIComponent
                onClick={() => onSelectUnit(x)}
                style={{
                  backgroundColor: getBackgroundClimateColor(x, theme),
                  width: getWidth(x),
                  color: getSelectedColor(x, theme),
                  cursor: getCursor(x),
                }}
                key={`row3-${x.id}`}
              >
                <h5 style={{ marginTop: 20 }}>{x.unitNumber}</h5>
                <div>{x.size}</div>
              </LIComponent>
            ))}
          </ULComponent>
        </TableComponent>
        <TableComponent>
          <ULComponent>
            {row4.map((x) => (
              <LIComponent
                onClick={() => onSelectUnit(x)}
                style={{
                  backgroundColor: getBackgroundColor(x, theme),
                  width: getWidth(x),
                  color: getSelectedColor(x, theme),
                  cursor: getCursor(x),
                }}
                key={`row4-${x.id}`}
              >
                <h5 style={{ marginTop: 20 }}>{x.unitNumber}</h5>
                <div>{x.size}</div>
              </LIComponent>
            ))}
          </ULComponent>
        </TableComponent>
      </div>
      <br />
      <div style={{ width: '100%' }}>
        <ActionsDivComponent
          onActionLeft={() => onActiveStep(2)}
          leftIcon={<NavigateBeforeIcon />}
          textLeft="Previous"
          colorLeft="inherit"
          leftVariant="outlined"
          onActionRight={() => onActiveStep(4)}
          rightIcon={<NavigateNextIcon />}
          textRight="Next"
          colorRight="primary"
          rightVariant="contained"
          disabledRight={isNextDisabled}
        />
      </div>
    </PaperComponent>
  )
}
